
// as "button" | "submit" | "reset"
// type: "button",
// size: "small" large | middle | small,
import { defineComponent } from "vue";
export default defineComponent({
  name: "OButton",
  props: {
    className: {
      type: String,
      require: false,
    },
    size: {
      type: String,
      require: false,
      default: "middle", // "large" | "middle" | "small"
    },
    type: {
      type: String,
      require: false,
      default: "dark", // "light" | "dark"
    },
    // text: String,
  },
  //   setup(props) {},
});
